const SpareParts = {

    // FIELDS
    "spare_parts": "Parts",
        "name": "Name",
    "description": "Description",
    "warranty": "Warranty",
    "status": "Status",
    "search": "Search",
    "parts": "Parts",

    // PAGE HEADER
    "list_title": "Spare Parts",
    "filter_title": "Spare Parts Filter",

    // TABLE HEADER
    "table_name": "Name",
    "table_warranty": "Warranty",
    "table_description": "Description",
    "table_status": "Status",
    "table_action": "Action",

    // ERROR
    "error_name": "Enter Name",
    "error_warranty": "Enter Warranty",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default SpareParts;

